import { render, staticRenderFns } from "./EconomicDashboard.vue?vue&type=template&id=436cc59e&"
import script from "./EconomicDashboard.vue?vue&type=script&lang=js&"
export * from "./EconomicDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports